import React from "react";
import "./MessageDisplay.scss";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ButtonNew } from "components/buttonNew";
import classNames from "classnames";

interface IAction {
  label: string;
  action: () => void;
  type?: "primary" | "secondary" | "tertiary";
  disabled?: boolean;
}

interface IProps {
  icon: IconName;
  title: string;
  content?: string;
  actions?: Array<IAction>;
  centered?: boolean;
}

export default function MessageDisplay(props: IProps) {
  const { title, content, actions, icon, centered } = props;

  return (
    <div className={classNames("ui-message-display", { "ui-message-display--centered": centered })}>
      <div className="ui-message-icon-container">
        <div className="ui-message-icon-container-inner">
          <FontAwesomeIcon className="event-icon-main" icon={["far", icon]} size="1x" />
        </div>
      </div>

      <p className="ui-message-title">{title}</p>
      {content ? <p className="ui-message-content">{content}</p> : null}

      {actions ? (
        <div className="ui-message-button-container">
          {actions?.map((action, index) => (
            <ButtonNew key={index} type={action?.type ?? "primary"} size="medium" onClick={action?.action} disabled={action?.disabled}>
              {action?.label}
            </ButtonNew>
          ))}
        </div>
      ) : null}
    </div>
  );
}
